// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar-module__default-scrollbar--dTV94 {
  --scrollbar-thumb: #8b8e96;
  --scrollbar-track: #fcfaf7;
}

.scrollbar-module__dark-scrollbar--gzPbm {
  --scrollbar-thumb: #5b5e68;
  --scrollbar-track: #090a0c;
}

.scrollbar-module__default-scrollbar--dTV94,
.scrollbar-module__dark-scrollbar--gzPbm {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

.scrollbar-module__default-scrollbar--dTV94::-webkit-scrollbar,
.scrollbar-module__dark-scrollbar--gzPbm::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scrollbar-module__default-scrollbar--dTV94::-webkit-scrollbar-track,
.scrollbar-module__default-scrollbar--dTV94::-webkit-scrollbar-corner,
.scrollbar-module__dark-scrollbar--gzPbm::-webkit-scrollbar-track,
.scrollbar-module__dark-scrollbar--gzPbm::-webkit-scrollbar-corner {
  background: var(--scrollbar-track);
}

.scrollbar-module__default-scrollbar--dTV94::-webkit-scrollbar-thumb,
.scrollbar-module__dark-scrollbar--gzPbm::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/utils/scrollbar/scrollbar.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;AACpB","sourcesContent":[".default-scrollbar {\n  --scrollbar-thumb: #8b8e96;\n  --scrollbar-track: #fcfaf7;\n}\n\n.dark-scrollbar {\n  --scrollbar-thumb: #5b5e68;\n  --scrollbar-track: #090a0c;\n}\n\n.default-scrollbar,\n.dark-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n.default-scrollbar::-webkit-scrollbar,\n.dark-scrollbar::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.default-scrollbar::-webkit-scrollbar-track,\n.default-scrollbar::-webkit-scrollbar-corner,\n.dark-scrollbar::-webkit-scrollbar-track,\n.dark-scrollbar::-webkit-scrollbar-corner {\n  background: var(--scrollbar-track);\n}\n\n.default-scrollbar::-webkit-scrollbar-thumb,\n.dark-scrollbar::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"default-scrollbar": `scrollbar-module__default-scrollbar--dTV94`,
	"dark-scrollbar": `scrollbar-module__dark-scrollbar--gzPbm`
};
export default ___CSS_LOADER_EXPORT___;
